import React, {Component} from 'react';
import {connect} from 'react-redux';
import store from 'store';

import {
    Card, CardBody,
    CardHeader,
    Col,
    FormGroup,
    Label,
    Row
} from 'reactstrap';
import {Field, reduxForm} from 'redux-form';

import {InputField} from "../../validation/ReduxFormInput";
import BoolButtons from '../../components/controls/buttons/BoolButtons';
import {normalizePhone} from "../../util/normalizers";
import {handleSetNotifications, handleSetPhoneNumber} from "../tenant/actions/tenant";
import PolyUtil from "../../util/PolyUtil";
import Loader from "../../components/display/Loader";
import {FormAsyncButton} from "../../components/controls/buttons/AsyncButton";

class ChangeNotifications extends Component {
    render() {
        const {
            handleSubmit,
            _handleSetEmailNotifications,
            _handleSetTextNotifications,
            _handleSetPhoneNumber,
            pristine,
            submitting,
            invalid,
            phone_verified,
            send_sms_notifications,
            send_email_notifications
        } = this.props;

        if (store.get('type') === 'tenant') {
            return (
                <Card className="pr-card">
                    <CardHeader tag="h4">Listing Recommendation Notifications</CardHeader>
                    <Loader spin isLoading={send_sms_notifications === undefined || send_email_notifications === undefined}>
                        <CardBody>
                            {
                                (!send_sms_notifications && !send_email_notifications) && (
                                    <h4 className="text-warning">
                                        <small><i className="fa fa-exclamation-triangle"/> You aren't currently receiving any notifications</small>
                                    </h4>
                                )
                            }
                            <form onSubmit={handleSubmit(_handleSetPhoneNumber)}>
                                <Field name="phone" label="Mobile Phone Number (for text notifications)" component={InputField} normalize={normalizePhone}/>
                                <Row>
                                    <Col xs={12} sm={6}>
                                        <FormGroup row>
                                            <Label sm={5}>
                                                Receive email notifications?
                                            </Label>
                                            <Col sm={7}>
                                                <BoolButtons defaultValue={send_email_notifications} noChange onChange={_handleSetEmailNotifications}/>
                                            </Col>
                                        </FormGroup>

                                        {
                                            !phone_verified && (
                                                <p style={{color: 'grey'}}>
                                                    <small>Verify your phone number to receive text notifications</small>
                                                </p>
                                            )
                                        }
                                        <FormGroup row>
                                            <Label sm={5}>
                                                Receive text (SMS) notifications?
                                            </Label>
                                            <Col sm={7}>
                                                <BoolButtons defaultValue={send_sms_notifications} noChange disabled={!phone_verified} onChange={_handleSetTextNotifications}/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormAsyncButton acting={submitting} type="submit" color="success" disabled={pristine || invalid}>Save</FormAsyncButton>
                            </form>
                        </CardBody>
                    </Loader>
                </Card>
            );
        } else return null;
    }
}

const validate = (values) => {
    const errors = {};

    !values.phone && (errors.phone = 'Required');
    (values.phone && values.phone.length < 12) && (errors.phone = 'Enter a valid phone number');

    return errors;
};

ChangeNotifications = reduxForm({
    form: 'settings_notifications',
    validate,
    enableReinitialize: true
})(ChangeNotifications);

const mapStateToProps = (state) => {
    return {
        send_email_notifications: state.tenant.send_email_notifications,
        send_sms_notifications: state.tenant.send_sms_notifications,
        phone_verified: state.tenant.phone_verified,
        initialValues: {
            phone: state.activeUser.phone ? PolyUtil.formatPhone(state.activeUser.phone) : ''
        }
    };
};

const mapDispatchToProps = (dispatch) => ({
    _handleSetEmailNotifications(value) {
        return dispatch(handleSetNotifications('email', value));
    },
    _handleSetTextNotifications(value) {
        return dispatch(handleSetNotifications('sms', value));
    },
    _handleSetPhoneNumber(data) {
        return dispatch(handleSetPhoneNumber(data));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeNotifications);


// WEBPACK FOOTER //
// ./src/containers/settings/ChangeNotifications.js